import * as zod from 'zod';

export const WeldMachineMode = zod.enum(['pulse', 'constantVoltage']);
